<div class="upload-doc {{class}}" [ngClass]="{
    'horizontal': layout == LAYOUT.HORIZONTAL,
    'vertical': layout == LAYOUT.VERTICAL
  }">
  <div class="doc-label-container">
    <p class="doc-label" [class.required]="required" >
      <mat-icon class="doc-icon" *ngIf="icon != false">{{icon}}</mat-icon>
      <span class="label">
        <ng-container *ngFor="let item of titles">
          {{ item | translate }}
        </ng-container>
        <ng-container *ngIf="titles?.length == 0">{{ "general.document" | translate }}</ng-container>
      </span>
    </p>
  </div>

  <div class="doc-action-container">
    <input [multiple]="multiple" [accept]="accept" type="file" hidden (change)="onFileChange($event)" #fileinput />
    <button mat-stroked-button class="m-button-outlined s-md" (click)="fileinput.value = ''; fileinput.click()">
      <mat-icon>attachment</mat-icon>
      {{ "button.upload_file" | translate }}
    </button>
  </div>
</div>
